module.exports = __webpack_public_path__ + "img/header-weddingRingsCheap@2x.4d2d6c4.webp";